import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../../utils/hooks/translateHook";
import "./Upgrade.css";

const Upgrade = () => {
  const t = useTranslation();
  return (
    <section className="upgrade-section">
      <div className="upgrade-card">
        <div className="upgrade-accent"></div>
        <div className="upgrade-content">
          <span className="upgrade-eyebrow"> {t("upgradeEyebrow")} </span>
          <h1> {t("upgradeTitle").toUpperCase()} </h1>
          <p className="upgrade-description"> {t("upgradeDescription")} </p>
          <div className="upgrade-actions">
            <Link to="/contactus" className="upgrade-contact-button">
              {t("upgradeContact")}
            </Link>
            <Link to="/courses" className="upgrade-secondary-link">
              {t("upgradeExplore")}
            </Link>
          </div>
        </div>
        <div className="upgrade-decoration">
          <span></span><span></span><span></span>
        </div>
      </div>
    </section>
  );
};

export default Upgrade;